module.exports = __webpack_public_path__ + "media/bootstrap-icons/play-circle-57b3fee1.svg";